interface DateInputProps {
  value: string | null | undefined;
  onChange: (value: string) => void;
  required?: boolean;
}

/** Bare <input type="date"> bound to a plain 'YYYY-MM-DD' string (the app's global date format). */
export function DateInput({ value, onChange, required }: DateInputProps) {
  return (
    <input
      type="date"
      required={required}
      value={value ?? ""}
      onChange={(e) => onChange(e.target.value)}
    />
  );
}
